import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	documentTitle: {
		id: 'products-jsw-storage-management-main.document-title',
		defaultMessage: 'Storage management',
		description: 'Title for a page where admins can manage storage (issue attachments)',
	},
	description: {
		id: 'products-jsw-storage-management-main.description',
		defaultMessage:
			'To free up space, click on the issues and remove attachments, or <link>upgrade for more storage</link>',
		description: 'Description for a page where admins can manage storage (issue attachments)',
	},
	// "Issue" can be renamed. How do we hook into the current name, and how do we find the plural?
	tableHeaderIssue: {
		id: 'products-jsw-storage-management-main.table-header-issue',
		defaultMessage: 'Issue',
		description: 'Table header for the column containing links to issues',
	},
	tableHeaderTotalAttachmentSize: {
		id: 'products-jsw-storage-management-main.table-header-total-attachment-size',
		defaultMessage: 'Total attachment size',
		description: "Table header for the column containing an issue's total attachment size",
	},
	// "Issue" can be renamed. How do we hook into the current name, and how do we find the plural?
	tableEmpty: {
		id: 'products-jsw-storage-management-main.table-empty',
		defaultMessage: 'No issues found',
		description:
			'An informative message to display when no issues with attachments could be retrieved for the current user',
	},
});
